<template>
  <page>
    <div>
      <v-container fluid grid-list-lg>
                <v-expansion-panels v-model="panel1" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                <v-layout row wrap>
                <message :messages="messages"></message>
                      <v-flex xs12 md6>
                        <cal-picker
                          v-model="form.tranDate"
                          :label="labels.tranDate"
                          :data-vv-as="labels.tranDate"
                          data-vv-name="form.tranDate"
                          :error-messages="errors.collect('form.tranDate')"
                          v-validate="'required'"
                          @change="doValidateTranDate()"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs12 md6>
                        <cal-picker
                          v-model="form.cutOffDate"
                          :label="labels.cutOffDate"
                          :data-vv-as="labels.cutOffDate"
                          data-vv-name="form.cutOffDate"
                          :error-messages="errors.collect('form.cutOffDate')"
                          v-validate="doValidateCutOffDate"
                          :max="new Date()"
                        ></cal-picker>
                      </v-flex>
        </v-layout>
                              </v-container>
                    </v-card-text>
                  </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                          <v-spacer class="mt-3"></v-spacer>
                <v-expansion-panels v-model="panel2" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-filter-variant</v-icon>Filters</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 md6>
                          <v-text-field
                            v-model="form.branch"
                            :label="labels.branch"
                            :error-messages="errors.collect('form.branch')"
                            data-vv-name="form.branch"
                            :data-vv-as="labels.branch"
                            readonly
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showBranchHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            v-model="form.curr"
                            :label="labels.curr"
                            :error-messages="errors.collect('form.curr')"
                            data-vv-name="form.curr"
                            :data-vv-as="labels.curr"
                            readonly
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showCurrencyHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                  </v-container>
                  </v-card-text>
                </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-spacer class="mt-3"></v-spacer>
                <v-btn class="mr-2" :loading="submitting" color="error" dark @click.prevent="doCancel"
                  >{{ labels.cancel }}<v-icon dark right>mdi-cancel</v-icon></v-btn
                >
                <v-btn :loading="submitting" color="primary" @click="doSubmit">{{ labels.schedule }}<v-icon dark right>mdi-clock</v-icon></v-btn>
      </v-container>
    </div>

    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="showBranchHelpList = false" @doAssign="doAssign('branch', $event)"></multi-branch-help-list>
    </v-dialog>

    <v-dialog v-model="showCurrencyHelpList" width="900px" persistent>
      <multi-currency-help-list
        :curr="form.curr"
        :param="'postExcDiff'"
        @close="showCurrencyHelpList = false"
        @doAssign="doAssign('currency', $event)"
      ></multi-currency-help-list>
    </v-dialog>

    <v-dialog v-model="promptExeJob" width="500px" persistent>
      <batch-job-scheduler
        v-if="promptExeJob"
        :skipValidate="batchForm.skipValidate"
        :jobKeys="form"
        :showJobMode="false"
        @close="promptExeJob = false"
        @doPopulate="processBatch($event)"
      />
    </v-dialog>

    <warning v-model="promptResubmit" @ok="doAccept">
      <div>{{ warningMsg1 }}</div>
      <div class="queryValue" v-for="(item, index) in bchJobDetails" :key="index">{{ item }}</div>
      <div>{{ warningMsg2 }}</div>
    </warning>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { commonMixins } from '@/mixins/common/commonMixin'
import { accountsAjaxCalls } from '@/mixins/accounting/accountsAjaxCalls'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList'
import MultiCurrencyHelpList from '@/components/core/common/dialog/MultiCurrencyHelpList'
import { expandURI } from '@/utils/ajax'
import BatchJobScheduler from '@/components/core/common/BatchJobScheduler'
import { batchManagerMixin } from '@/mixins/common/batchManagerMixin'

export default {
  data() {
    return {
      labels: {
        tranDate: 'Set Transaction Date for Exchange Differences',
        cutOffDate: 'Cut Off Date',
        revalueOS: 'Revalue Outstanding Transaction',
        add1DayExRate: 'Add 1 Day For Exchange Rate',
        branch: 'Branch',
        curr: 'Currency',
        cancel: 'Cancel',
        schedule: 'Schedule',
        submit: 'Submit'
      },
      form: {
        tranDate: new Date(),
        cutOffDate: new Date(),
        revalueOS: false,
        add1DayExRate: false,
        branch: 'All',
        curr: 'All'
      },
      loading: false,
      submitting: false,
      showBranchHelpList: false,
      showCurrencyHelpList: false,
      promptExeJob: false,
      scheduleForm: {
        jobName: 'qrtzPostExDiff',
        jobDesc: 'Post Exchange Differences'
      },
      panel1: [0],
      panel2: [0]
    }
  },
  methods: {
    async doInit() {
      this.loading = true
      await Promise.all([this.$store.dispatch('accountsInit')])
      await Promise.all([this.$store.dispatch('voidPostExchangeDifferencesInit')])
      this.doValidateTranDate()
      this.loading = false
    },
    doCancel() {
      this.$router.push({ name: 'specFuncAcct' }).catch(() => {})
    },
    doSubmit() {
      this.promptResubmit = false
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.isBatchManager === true) {
            this.promptExeJob = true
          } else {
            this.doSchedule()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doSchedule() {
      const apiURI = this.menu.doSchedule
      if (apiURI) {
        try {
          this.submitting = true
          const result = this.$http.post(apiURI, this.form)
          if (result) {
            this.$toast.success('Job successfully submitted to batch job process.')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async processBatch(bmForms) {
      const apiURI = this.menu.exeBatch
      if (apiURI) {
        try {
          this.submitting = true
          const result = await this.$http.post(apiURI, bmForms)
          if (result.data) {
            const { data } = result.data
            if (data.prevBchJobs && data.prevBchJobs.length > 0) {
              this.promptResubmit = true
              this.getBchJobDetails(data.prevBchJobs)
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
      this.batchForm.skipValidate = false
    },
    doAssign(fieldName, obj) {
      switch (fieldName) {
        case 'branch':
          this.form.branch = obj.finalSelectedItems.toString()
          this.showBranchHelpList = false
          break
        case 'currency':
          this.form.curr = obj.finalSelectedItems.toString()
          this.showCurrencyHelpList = false
          break
      }
    },
    async doValidateTranDate() {
      const apiURI = this.menu.validateTranDate
      if (apiURI) {
        this.dateLoading = true
        try {
          const expand = {
            tranDate: this.form.tranDate
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.resetMessage('form.tranDate')
          this.dateLoading = false
        } catch (err) {
          this.dateLoading = false
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('valToday', {
      getMessage(field, args) {
        return 'Cannot be greater / later than system date(TODAY)'
      },
      validate(value, args) {
        if (value) {
          return !isAfter(removeTime(value), removeTime(new Date()))
        }
        return true
      }
    })
    this.$validator.extend('valTranDate', {
      getMessage(field, args) {
        return 'Cannot be greater / later than Set Transaction Date for Exchange'
      },
      validate(value, args) {
        let tranDate = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(tranDate))
        }
        return true
      }
    })
  },
  computed: {
    menu() {
      return this.$store.state.specFuncAcct.postExchangeDifferences.menu
    },
    doValidateCutOffDate() {
      if (this.form.cutOffDate !== '' && this.form.cutOffDate !== undefined && this.form.cutOffDate !== null) {
        return 'required|valTranDate:' + this.form.tranDate + '|valToday'
      } else {
        return 'required'
      }
    }
  },
  watch: {},
  mixins: [MessageMixin, commonAjaxMixin, commonMixins, accountsAjaxCalls, batchManagerMixin],
  components: {
    MultiBranchHelpList,
    MultiCurrencyHelpList,
    BatchJobScheduler
  }
}
</script>
<style lang="scss"></style>
